import React from "react";
import { useUscSelector } from "../../../../redux/store";
import { UscLabel } from "../../../../utils/labels";
import { getEnabledServices } from "../../../../utils/helpers";
import Text from "../../styles/atoms/Text";
import * as Styles from "./PdpServices.styles";
import PdpServiceCard from "./PdpDefaultServiceCard";
import { useComponentRegistry } from "../../componentRegistry";

const PdpServices = (): JSX.Element | null => {
    const vehicle = useUscSelector((state) => state.vehicle);
    const dealer = useUscSelector((state) => state.dealer.dealer);
    const uscSettings = useUscSelector((state) => state.uscSettings);
    const ServicesWithDetailsList = useComponentRegistry("ServicesWithDetailsList");

    if (!vehicle.result) return null;

    const enabledServices = getEnabledServices(vehicle, uscSettings, dealer);

    // pdpSectionSelector will hide this section if no services are available.
    // If we ever have more services be sure to update pdpSectionSelector as well.
    return (
        <Styles.Wrapper>
            <Text tag="h2" variant="h4">
                <UscLabel label="uscServicesPdpTitle" />
            </Text>
            {!!enabledServices.length && (
                <Styles.ServicesList role="list">
                    {enabledServices.map((service) => (
                        <li key={service}>
                            <PdpServiceCard service={service} />
                        </li>
                    ))}
                </Styles.ServicesList>
            )}

            <ServicesWithDetailsList />

            {!!enabledServices.length && (
                <Text tag="p" variant="body-book" color="primary-black" center>
                    <UscLabel label="uscServicesPdpDescription" />
                </Text>
            )}
        </Styles.Wrapper>
    );
};

export default PdpServices;
